<template>
  <router-view />
</template>

<script setup>
</script>

<style>
/* 全局样式 */
</style>
